import type { ReactNode } from "react";
import { cn } from "./ui/utils";

interface PageHeaderProps {
	title: ReactNode;
	description?: ReactNode;
	actions?: ReactNode;
	className?: string;
}

export function PageHeader({
	title,
	description,
	actions,
	className,
}: PageHeaderProps) {
	return (
		<header
			className={cn(
				"flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between",
				className,
			)}
		>
			<div className="min-w-0 space-y-2">
				<h1 className="text-[34px] font-bold leading-tight tracking-[-0.025em] text-foreground">
					{title}
				</h1>
				{description ? (
					<p className="max-w-3xl text-[15px] font-medium leading-6 text-muted-foreground">
						{description}
					</p>
				) : null}
			</div>
			{actions ? (
				<div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center lg:justify-end">
					{actions}
				</div>
			) : null}
		</header>
	);
}
